import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfileStore } from "../../shared/store/profile.store";
import { ButtonLarge } from "../../shared/uikit";

const slides = [
  {
    icon: "🔐",
    title: "Welcome to CryptCloud",
    description:
      "Your secure cloud encryption platform. Manage your devices, companies, and encrypted access all in one place.",
  },
  {
    icon: "📷",
    title: "QR Code Login",
    description:
      "Scan QR codes to securely log into the CryptCloud desktop app. No passwords needed — just scan and confirm.",
  },
  {
    icon: "📱",
    title: "Device Management",
    description:
      "View and manage all devices connected to your account. Log out or remove devices remotely.",
  },
  {
    icon: "🏢",
    title: "Company Registration",
    description:
      "Register your company for business encryption features. Track moderation status and manage company details.",
  },
];

export const OnboardingPage = () => {
  const navigate = useNavigate();
  const { setOnboardingCompleted } = useProfileStore.getState();
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      localStorage.setItem("onboarding_completed", "true");
      setOnboardingCompleted(true);
      navigate("/devices", { replace: true });
    }
  };

  const handleSkip = () => {
    localStorage.setItem("onboarding_completed", "true");
    setOnboardingCompleted(true);
    navigate("/devices", { replace: true });
  };

  const slide = slides[currentSlide];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        padding: "2rem",
      }}
    >
      {/* Progress dots */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "8px",
          marginBottom: "2rem",
        }}
      >
        {slides.map((_, i) => (
          <div
            key={i}
            style={{
              width: i === currentSlide ? "24px" : "8px",
              height: "8px",
              borderRadius: i === currentSlide ? "12px" : "50%",
              background:
                i === currentSlide
                  ? "var(--accent-color)"
                  : "var(--border-color)",
              transition: "all 0.3s",
            }}
          />
        ))}
      </div>

      {/* Slide content */}
      <div style={{ textAlign: "center", flex: 1 }}>
        <div style={{ fontSize: "64px", marginBottom: "1rem" }}>
          {slide.icon}
        </div>
        <h1 style={{ marginBottom: "1rem" }}>{slide.title}</h1>
        <p
          style={{
            color: "var(--second-color)",
            fontSize: "16px",
            lineHeight: 1.6,
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {slide.description}
        </p>
      </div>

      {/* Navigation */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem 0",
        }}
      >
        <ButtonLarge
          title="Skip"
          onClick={handleSkip}
          mode="white"
          isSmall={true}
        />

        <div style={{ flex: 1 }} />

        <ButtonLarge
          title={currentSlide < slides.length - 1 ? "Next" : "Get Started"}
          onClick={handleNext}
          mode="black"
        />
      </div>
    </div>
  );
};
